export const projectMember = {
    add: '添加成员',
    share: '分享邀请',
    designer: '设计师',
    builders: '施工方',
    user: '客户',
    designerAuthority:
        '有权限编辑项目内容、更新方案详情、对方案进行标注、上传音视频；',
    buildersAuthority:
        '有权限查看项目内容，对方案进行标注、上传音视频、更新施工进度；',
    userAuthority: '有权限查看项目内容，对方案进行标注、上传音视频；',
    copySuccess: '复制成功，快把链接分享给成员吧！',
    memberLimit: '每个项目可添加5位设计师、2位客户，2个施工',
    selectRole: '选择被邀请人身份',
    generateLink: '生成邀请链接',
    shareLink: '链接分享',
    copy: '复制链接',
    teamInvite: '邀请团队成员',
};
